module.exports = __webpack_public_path__ + "img/icon-cunzheng.83f91bef.svg";